// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"ach-payment-method__image___1rrlP","image-container":"ach-payment-method__image-container___1Jpx8","imageContainer":"ach-payment-method__image-container___1Jpx8","image-description":"ach-payment-method__image-description___2_G7p","imageDescription":"ach-payment-method__image-description___2_G7p","image-active":"ach-payment-method__image-active___2DTR_","imageActive":"ach-payment-method__image-active___2DTR_"};
    if(module.hot) {
      // 1745801640402
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  